module.exports = __webpack_public_path__ + "static/media/est_0004_f.568a8cd9.jpg";